// extracted by mini-css-extract-plugin
module.exports = {"landing_page_G1":"G1_landing_page_G1__A_rKJ"};